import { createSelector } from '@reduxjs/toolkit'
import { timeScheduleSlice } from '..'

export const dialogTotalSelector = createSelector(
  [timeScheduleSlice.selectors.addedServices],
  (addedServices): number => {
    return Object.values(addedServices).reduce<number>((acc, service) => {
      return acc + service.timeSchedule.price * service.bought
    }, 0)
  }
)
